import { useEffect, useState } from "react";
import {
  convertWorkStatus,
  createShiftPlan,
  getLanguage,
  noneBranchObject,
  noneShiftObject,
  pageIsSearchable,
} from "../Managers/dataProvider";
import {
  AlertDialogModel,
  EnumActivityIndicatorState,
  EnumAlertDialogType,
  EnumEmployeeShiftState,
  EnumMenuType,
  EnumPopupFunctions,
  EnumUserAcces,
  PopupInfoModel,
  ShiftLogModel,
  ShiftPlanEmployee,
  ShiftPlanModel,
} from "../Managers/dataStructures";
import {
  filterAttendanceEmployeeData,
  formateDateTimeToServerDateString,
} from "../Managers/utilityFunctions";
import { updateShiftLog } from "../Managers/wepApiManager";
import {
  processEmployeeShiftState,
  processForceEndEmployeeShift,
  processGetTLShiftPlan,
} from "../Managers/processManager";
import { TLEmployeeDialogProps } from "./TLEmployeeDialog";
import { getCurrentUser } from "../Managers/profileManager";
import { ActivityIndicator } from "../Managers/utilityComponents";

interface TLAttendanceListProps {
  openInfoDialog: (item: PopupInfoModel) => void;
  openReturnDialog: (item: PopupInfoModel) => boolean;
  searchString: string;
}

export default function TLAttendanceList(props: TLAttendanceListProps) {
  const isEnglish = getLanguage();
  const [isSubmitIndicator, setIsSubmitIndicator] = useState<boolean>(false);
  const [isActivityIndicator, setIsActivityIndicator] =
    useState<boolean>(false);
  const [shiftPlanObj, setShiftPlanObj] = useState<ShiftPlanModel>(
    createShiftPlan(new Date(), noneBranchObject(), noneShiftObject())
  );
  const searchString: string = pageIsSearchable(
    EnumMenuType.TEAM_LEAD_ATTENDANCE_LIST
  )
    ? props.searchString
    : "";
  const isShiftEndable: boolean = checkForEndStateOfAllEmployees();

  useEffect(() => {
    setIsActivityIndicator(true);
    processGetTLShiftPlan(
      new Date(),
      getCurrentUser().user_id,
      (shift_plan: ShiftPlanModel | undefined) => {
        setIsActivityIndicator(false);
        if (shift_plan !== undefined) {
          shift_plan.array_employees.sort((x, y) => {
            return x.user.first_name > y.user.first_name ? 1 : -1;
          });

          setShiftPlanObj(shift_plan);
        }
      },
      (shift_plan: ShiftPlanModel | undefined) => {
        if (shift_plan !== undefined) {
          shift_plan.array_employees.sort((x, y) => {
            return x.user.first_name > y.user.first_name ? 1 : -1;
          });
          setShiftPlanObj(shift_plan);
          window.location.reload();
        }
      }
    );
  }, []);

  function isShiftPending() {
    if (shiftPlanObj.array_employees.length === 0) {
      return false;
    }
    // if (isShiftEndable === false) {
    //   return true;
    // }
    if (
      shiftPlanObj.log !== null &&
      shiftPlanObj.log !== undefined &&
      shiftPlanObj.log_id !== "-1"
    ) {
      if (
        shiftPlanObj.log.end_at === undefined ||
        shiftPlanObj.log.end_at === "" ||
        shiftPlanObj.log.end_at === null
      ) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  function checkForEndStateOfAllEmployees() {
    const sIndex: number = shiftPlanObj.array_employees.findIndex(
      (x) => x.current_state !== EnumEmployeeShiftState.SHIFT_ENDED
    );
    if (sIndex === -1) {
      return true;
    }
    return false;
  }

  function selectUserHandler(shift_employee: ShiftPlanEmployee) {
    const tlEProps: TLEmployeeDialogProps = {
      shift_plan_employee: shift_employee,
      startPauseShift: (
        employee: ShiftPlanEmployee,
        callback_: (isActivity: EnumActivityIndicatorState) => void
      ) => {
        let tempShiftPlan = shiftPlanObj;

        const eIndex: number = tempShiftPlan.array_employees.findIndex(
          (x) => x.user_id === employee.user_id
        );

        callback_(EnumActivityIndicatorState.START_STOP_SHIFT);
        processEmployeeShiftState(
          shift_employee,
          shiftPlanObj.log_id !== undefined ? shiftPlanObj.log_id : "-1",
          (isSuccess: boolean, newState: EnumEmployeeShiftState) => {
            if (eIndex !== -1 && isSuccess) {
              tempShiftPlan.array_employees[eIndex].current_state = newState;
              setShiftPlanObj(tempShiftPlan);
            }
            callback_(EnumActivityIndicatorState.NOT_RUNNING);
          }
        );
      },
      endShift: (
        employee: ShiftPlanEmployee,
        callback_: (isActivity: EnumActivityIndicatorState) => void
      ) => {
        callback_(EnumActivityIndicatorState.END_SHIFT);
        const user_id =
          employee.user_id !== undefined ? employee.user_id : "-1";
        const shift_log_id =
          shiftPlanObj.log_id !== undefined ? shiftPlanObj.log_id : "";
        if (shift_log_id === "") {
          showDialog(
            EnumAlertDialogType.NEGATIVE,
            isEnglish ? "Error" : "Fehler",
            isEnglish
              ? "Failed to end employee shift check your internet please"
              : "Fehler beim Beenden des Mitarbeiterschicht. Bitte überprüfen Sie Ihr Internet."
          );
          return;
        }
        processForceEndEmployeeShift(
          employee,
          user_id,
          shift_log_id,
          (isSuccess: boolean, newState: EnumEmployeeShiftState) => {
            let tempShiftPlan = shiftPlanObj;
            const eIndex: number = tempShiftPlan.array_employees.findIndex(
              (x) => x.user_id === employee.user_id
            );

            if (eIndex !== -1 && isSuccess) {
              tempShiftPlan.array_employees[eIndex].current_state = newState;
              setShiftPlanObj(tempShiftPlan);
              callback_(EnumActivityIndicatorState.NOT_RUNNING);
              showDialog(
                EnumAlertDialogType.POSITIVE,
                isEnglish ? "Success" : "Vielen Dank",
                isEnglish
                  ? "Shift has been ended successfully."
                  : "Ihre Schicht wurde erfolgreich beendet."
              );
            }
          }
        );
      },
      closeDialog: () => {},
    };
    const item: PopupInfoModel = {
      item: shift_employee,
      props: tlEProps,
      ftype: EnumPopupFunctions.TL_USER_LOGIN_DIALOG,
      callback: (item: any) => {
        console.log("login dialog returned=");
      },
    };
    props.openInfoDialog(item);
  }

  function forceEndEmployeeShift(shift_employee: ShiftPlanEmployee) {
    const item: PopupInfoModel = {
      item: shift_employee,
      ftype: EnumPopupFunctions.TL_FORCE_CLOSE_DIALOG,
      callback: () => {
        endForceEmployeeShift(shift_employee);
      },
    };

    props.openInfoDialog(item);
  }

  async function endForceEmployeeShift(shift_employee: ShiftPlanEmployee) {
    const ended_by_id: string = getCurrentUser().user_id;
    const shift_log_id =
      shiftPlanObj.log_id !== undefined ? shiftPlanObj.log_id : "";
    if (shift_log_id === "") {
      showDialog(
        EnumAlertDialogType.NEGATIVE,
        isEnglish ? "Error" : "Fehler",
        isEnglish
          ? "Failed to end employee shift check your internet please"
          : "Fehler beim Beenden des Mitarbeiterschicht. Bitte überprüfen Sie Ihr Internet."
      );
      return;
    }
    processForceEndEmployeeShift(
      shift_employee,
      ended_by_id,
      shift_log_id,
      (isSuccess: boolean, newState: EnumEmployeeShiftState) => {
        if (isSuccess) {
          let tempShiftPlan = shiftPlanObj;
          const eIndex: number = tempShiftPlan.array_employees.findIndex(
            (x) => x.user_id === shift_employee.user_id
          );

          if (eIndex !== -1 && isSuccess) {
            tempShiftPlan.array_employees[eIndex].current_state = newState;
            setShiftPlanObj(tempShiftPlan);
          }
          showDialog(
            EnumAlertDialogType.POSITIVE,
            isEnglish
              ? "Force Closure success"
              : "Schicht zwangsweise beenden erfolgreich.",
            isEnglish
              ? "Employee current shift have been successfully closed."
              : "Die aktuelle Schicht des Mitarbeiters wurde erfolgreich beendet."
          );
        } else {
          showDialog(
            EnumAlertDialogType.NEGATIVE,
            isEnglish ? "Error" : "Fehler",
            isEnglish
              ? "Failed to end employee shift check your internet please"
              : "Fehler beim Beenden des Mitarbeiterschicht. Bitte überprüfen Sie Ihr Internet."
          );
        }
      }
    );
    //const isSuccess: boolean = await endEmployeeShiftAPI(shift_employee);
  }

  function endShift() {
    let isEmployeeStatusEnded: boolean = true;
    for (let i = 0; i < shiftPlanObj.array_employees.length; i++) {
      if (
        shiftPlanObj.array_employees[i].current_state !==
          EnumEmployeeShiftState.SHIFT_ENDED &&
        shiftPlanObj.array_employees[i].current_state !==
          EnumEmployeeShiftState.UNKNOWN
      ) {
        isEmployeeStatusEnded = false;
        break;
      }
    }
    if (isEmployeeStatusEnded) {
      const item_: PopupInfoModel = {
        item: null,
        ftype: EnumPopupFunctions.TL_END_SHIFT_DIALOG,
        callback: async () => {
          //const isSuccess: boolean = await endEntireShiftAPI(shiftPlanObj);
          submitShiftReport();
        },
      };
      props.openInfoDialog(item_);
    } else {
      showDialog(
        EnumAlertDialogType.NEGATIVE,
        isEnglish ? "Error Ending Shift" : "Fehler beim Beenden der Schicht",
        isEnglish
          ? "All Employee shifts must be ended before ending the entire shift."
          : "Alle Mitarbeiterschichten müssen beendet werden, bevor die gesamte Schicht beendet wird."
      );
    }
  }

  function submitShiftReport() {
    let shift_log: ShiftLogModel = {
      id: shiftPlanObj.log_id !== undefined ? shiftPlanObj.log_id : "",
      plan_id: shiftPlanObj.plan_id !== undefined ? shiftPlanObj.plan_id : "",
      comments: "",
      end_at: formateDateTimeToServerDateString(new Date()),
      approval_status: false,
      approved_by_user_id: "",
    };
    setIsSubmitIndicator(true);
    updateShiftLog(
      shift_log,
      (isSuccess: boolean, shift_log: ShiftLogModel) => {
        setIsSubmitIndicator(false);
        if (isSuccess) {
          let tempShiftPlan = shiftPlanObj;
          tempShiftPlan.log = shift_log;
          setShiftPlanObj(tempShiftPlan);
          showDialog(
            EnumAlertDialogType.POSITIVE,
            isEnglish ? "Succes" : "Vielen Dank",
            isEnglish
              ? "Report Submission succcessfull."
              : "Bericht wurde erfolgreich versandt."
          );
        } else {
          showDialog(
            EnumAlertDialogType.NEGATIVE,
            "Error Submit Report",
            "Check your internet Connection."
          );
        }
      }
    );
  }

  function showDialog(
    type_: EnumAlertDialogType,
    title: string,
    a_desc: string
  ) {
    const alert: AlertDialogModel = {
      type: type_,
      alert_title: title,
      alert_description: a_desc,
      dismiss_button_text: isEnglish ? "Dismiss Alert" : "Fenster schliessen",
    };
    const item: PopupInfoModel = {
      item: alert,
      ftype: EnumPopupFunctions.ALERT_DIALOG,
    };
    props.openInfoDialog(item);
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish ? "Attendance List Page" : "Übersicht Arbeitsplan"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? 'List of employees that belong to current shift. Employees can tap on thier names to "Sign in" and Start/Pause thier work Timer or end thier work shift. All Employees need to end thier shift before the shift can end. Team Leader can force end an employees shift if employee failed to end thier shift.'
              : 'Unten sind die eingeplanten Mitarbeiter für die aktuelle Schicht aufgelistet. Mitarbeiter können ihre Arbeit beginnen oder beenden, indem sie auf ihren Namen klicken und sich mit ihrem Passwort anmelden. Nach der Anmeldung können sie die Schicht mit dem "Arbeit beginnen"-Button starten oder pausieren. Alle Mitarbeiter müssen sich beim Beenden ihrer Arbeit erneut anmelden und die Schicht aktiv beenden. Der Teamleiter kann die Schichten für die Mitarbeiter ebenfalls beenden.'}
          </p>
        </div>
        {isShiftPending() === true ? (
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <button
              onClick={endShift}
              type="button"
              className="block rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            >
              {isSubmitIndicator === true ? ActivityIndicator(0) : null}
              {isShiftEndable
                ? isEnglish
                  ? "Submit Shift Report"
                  : "Filialtagesbericht versenden"
                : isEnglish
                ? "End Shift"
                : "Schicht beenden"}
            </button>
          </div>
        ) : null}
      </div>

      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            {isActivityIndicator === true ? (
              <div className="min-w-full h-20 flex flex-row items-center justify-center">
                {ActivityIndicator(1)}
              </div>
            ) : (
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      {isEnglish ? "Name" : "Name"}
                    </th>

                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {isEnglish ? "Status" : ""}
                    </th>

                    <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                    >
                      <span className="sr-only">
                        {isEnglish
                          ? "Force End Shift"
                          : "Schichtende erzwingen"}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {filterAttendanceEmployeeData(
                    shiftPlanObj.array_employees,
                    searchString
                  ).map((x) => [
                    userCell(
                      x,
                      selectUserHandler,
                      forceEndEmployeeShift,
                      isShiftPending()
                    ),
                  ])}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function userCell(
  user: ShiftPlanEmployee,
  handler: (user: ShiftPlanEmployee) => void,
  forceEndEmployeeShift_: (user: ShiftPlanEmployee) => void,
  isShiftEnded: boolean
) {
  const isEnglish = getLanguage();
  function selectCellhandler() {
    handler(user);
  }

  function forceEndEmployeeShift() {
    forceEndEmployeeShift_(user);
  }

  return (
    <tr key={user.user.user_id}>
      <td
        onClick={selectCellhandler}
        className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0"
      >
        <div className="flex items-center">
          <div className="h-11 w-11 flex-shrink-0">
            <img
              className="h-11 w-11 rounded-full"
              src={user.user.profile_pic_url}
              alt=""
            />
          </div>
          <div className="ml-4">
            <div className="font-medium text-gray-900">
              {user.user.first_name + " " + user.user.last_name}
              {user.user.role.type === EnumUserAcces.TEAM_LEAD ? (
                <span
                  className={
                    "inline-flex ml-2 items-center rounded-md  px-2 py-1 text-xs font-medium ring-1 ring-inset " +
                    user.user.role.color_scheme
                  }
                >
                  {user.user.role.display_name}
                </span>
              ) : null}
            </div>
            <div className="mt-1 text-gray-500">{user.user.employee_id}</div>
          </div>
        </div>
      </td>

      <td
        onClick={selectCellhandler}
        className="whitespace-nowrap px-3 py-5 text-sm text-gray-500"
      >
        <span
          className={
            "inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium ring-1 ring-inset " +
            convertWorkStatus(user.current_state).color_scheme
          }
        >
          {convertWorkStatus(user.current_state).display_name}
        </span>
      </td>
      {user.current_state !== EnumEmployeeShiftState.SHIFT_ENDED &&
      isShiftEnded === true ? (
        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
          <a
            onClick={selectCellhandler}
            href={"#" + user.user.user_id}
            className="text-indigo-600 hover:text-indigo-900"
          >
            {isEnglish ? "Login" : "Login"}
            <span className="sr-only">{", " + user.user.email_id}</span>
          </a>
        </td>
      ) : null}
      {user.current_state !== EnumEmployeeShiftState.SHIFT_ENDED &&
      isShiftEnded === true ? (
        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
          <a
            onClick={forceEndEmployeeShift}
            href={"#" + user.user.user_id}
            className="text-indigo-600 hover:text-indigo-900"
          >
            {isEnglish ? "Force End Shift" : "Schichtende erzwingen"}
            <span className="sr-only">{", " + user.user.email_id}</span>
          </a>
        </td>
      ) : null}
    </tr>
  );
}
